module.exports = __webpack_public_path__ + "img/1784792584853-Tas Ilung - Lisda 0512.jpg.f3583aff.webp";